import { clearSplitBoundsBrandedFareParams } from "./splitBoundsBrandedFareParams.js";
export function getRoundtripSearchUrl(data, caSource, prevSearchParams) {
    const searchParams = new URLSearchParams(prevSearchParams);
    clearSplitBoundsBrandedFareParams(searchParams);
    searchParams.set("type", "ROUNDTRIP");
    searchParams.set("adults", "1");
    searchParams.set("cabinClass", "ECONOMY");
    searchParams.set("sort", "BEST");
    searchParams.set("depart", data.departureDate);
    searchParams.set("from", data.fromIata);
    searchParams.set("to", data.toIata);
    if (data.returnDate)
        searchParams.set("return", data.returnDate);
    if (data.popular)
        searchParams.set("popular", "1");
    if (data.datesChanged === false)
        searchParams.set("open_datepicker", "1");
    return `/flights/${data.fromIata}-${data.toIata}/?${searchParams.toString()}&ca_source=${caSource}`;
}
export function getOnewaySearchUrl(data, caSource, prevSearchParams) {
    const searchParams = new URLSearchParams(prevSearchParams);
    clearSplitBoundsBrandedFareParams(searchParams);
    searchParams.set("type", "ONEWAY");
    searchParams.set("adults", "1");
    searchParams.set("cabinClass", "ECONOMY");
    searchParams.set("sort", "BEST");
    searchParams.set("from", data.fromIata);
    searchParams.set("to", data.toIata);
    if (data.departureDate)
        searchParams.set("depart", data.departureDate);
    if (data.popular)
        searchParams.set("popular", "1");
    if (data.datesChanged === false)
        searchParams.set("open_datepicker", "1");
    return `/flights/${data.fromIata}-${data.toIata}/?${searchParams.toString()}&ca_source=${caSource}`;
}
